module.exports = __webpack_public_path__ + "static/media/sub.4eb05fdd.png";